import Swal, {
  SweetAlertIcon,
  SweetAlertOptions,
  SweetAlertPosition,
} from 'sweetalert2-unrestricted'
import 'sweetalert2-unrestricted/dist/sweetalert2.min.css'

export function showToast(args: {
  icon: SweetAlertIcon
  title: string
  position?: SweetAlertPosition
}) {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: toast => {
      toast.onmouseenter = Swal.stopTimer
      toast.onmouseleave = Swal.resumeTimer
    },
  })
  Toast.fire({
    icon: args.icon,
    title: args.title,
    position: args.position || 'top-end',
  })
}
